function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { Wrapper } from './styles';

var Container = function Container(_ref) {
  var _ref$constrainWidth = _ref.constrainWidth,
      constrainWidth = _ref$constrainWidth === void 0 ? true : _ref$constrainWidth,
      _ref$disableGutter = _ref.disableGutter,
      disableGutter = _ref$disableGutter === void 0 ? false : _ref$disableGutter,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'div' : _ref$component,
      rest = _objectWithoutProperties(_ref, ["constrainWidth", "disableGutter", "component"]);

  return /*#__PURE__*/React.createElement(Wrapper, Object.assign({
    as: component,
    disableGutter: disableGutter,
    constrainWidth: constrainWidth
  }, rest));
};

export default Container;